import React, { HTMLAttributes } from 'react'
import { TextSizeType, TextThemeType } from '../../_config/types'
import { getThemedText } from '../../_common/functions'

interface ButtonProps extends HTMLAttributes<HTMLParagraphElement> {
    theme?: TextThemeType
    size?: TextSizeType
    className?: string
}

const Text: React.FC<ButtonProps> = ({ children, theme = '', size = 'md', className = '', ...args }) => {
    const getSize = () => {
        switch (size) {
            case 'xxl':
                return 'text-[0.917rem] leading-[1.375rem]'
            case 'xl':
                return 'text-[0.833rem] leading-[1.25rem]'
            case '19':
            case 'lg1':
                return 'text-[0.792rem] leading-[1.188rem]'
            case 'lg':
            case '18':
                return 'text-[0.75rem] leading-[1.125rem]'
            case 'md':
                return 'text-[0.667rem] leading-[1rem]'
            case '15':
                return 'text-[0.625rem] leading-[0.938rem]'
            case '14':
            case 'sm':
                return 'text-[0.583rem] leading-[0.917rem]'
            case '12':
                return 'text-[0.5rem] leading-[0.75rem]'
            case 'xs':
            case '13':
                return 'text-[0.542rem] leading-[0.833rem]'
            case 'xxs':
                return 'text-[0.458rem] leading-[0.688rem]'
            default:
                return 'text-[1rem] leading-[0.75rem]'
        }
    }
    return (
        <p className={`${getThemedText(theme)} ${getSize()} ${className}`} {...args}>
            {children}
        </p>
    )
}

export default Text
